/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromoteFromWaitlistBody
 */
export interface PromoteFromWaitlistBody {
    /**
     * Specific team to promote. Defaults to the head of the queue.
     * @type {string}
     * @memberof PromoteFromWaitlistBody
     */
    teamId?: string;
    /**
     * Why the team was promoted. Recorded on the admin audit row.
     * @type {string}
     * @memberof PromoteFromWaitlistBody
     */
    reason?: string;
}

/**
 * Check if a given object implements the PromoteFromWaitlistBody interface.
 */
export function instanceOfPromoteFromWaitlistBody(value: object): value is PromoteFromWaitlistBody {
    return true;
}

export function PromoteFromWaitlistBodyFromJSON(json: any): PromoteFromWaitlistBody {
    return PromoteFromWaitlistBodyFromJSONTyped(json, false);
}

export function PromoteFromWaitlistBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoteFromWaitlistBody {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function PromoteFromWaitlistBodyToJSON(json: any): PromoteFromWaitlistBody {
    return PromoteFromWaitlistBodyToJSONTyped(json, false);
}

export function PromoteFromWaitlistBodyToJSONTyped(value?: PromoteFromWaitlistBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'reason': value['reason'],
    };
}

